<script setup lang="ts">
import { computed } from 'vue';
import { useI18nLocalize } from '@/i18n/i18nLocalize';
import { handleBeforeSendImage, handleSelectFile } from '@/utils';
import { useUserAuthorizationsStore } from '@/store/UserAuthorizationsStore';
import FileUpload from 'primevue/fileupload';

const props = defineProps<{
  logo: any;
  url?: string;
  data?: object;
}>();

const emits = defineEmits<{ 'update:logo': [value: any] }>();

const { i18nLocale } = useI18nLocalize();
const { $t } = i18nLocale(props.data.lang);
const userAuthorizationsStore = useUserAuthorizationsStore();
const authorizations: any = userAuthorizationsStore.permissionByRole;

const logo = computed({
  get() {
    return props.logo;
  },
  set(value) {
    emits('update:logo', value);
  }
});

const onUploadImg = (res: any) => {
  if (res.xhr.status === 200) {
    logo.value = res.xhr.response;
  }
};
</script>
<template>
  <tr>
    <td class="w-5">
      <div class="wrapper image flex">
        <div class="mr-5 w-17rem h-5rem flex justify-content-center">
          <div v-if="!logo" class="text-lg font-semibold">{{ $t('client_copy.upload_logo') }}</div>
          <img v-else alt="aircanada-logo" :src="logo" class="logo" />
        </div>
        <FileUpload
          v-if="authorizations?.my_quote?.client_copy_edit"
          mode="basic"
          name="file"
          :auto="true"
          :url="url"
          :chooseLabel="$t('client_copy.upload_logo')"
          accept="image/*"
          :maxFileSize="5000000"
          @upload="onUploadImg($event)"
          @select="handleSelectFile"
          @before-send="handleBeforeSendImage"
          :invalid-file-size-message="$t('notification.validSizeImg')"
        />
      </div>
    </td>
    <td colspan="2" class="w-5">
      <table class="w-full text-right">
        <thead>
          <tr>
            <th class="hidden"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <ul class="no-bullets">
                <li class="text-2xl">
                  {{ $t('client_copy.group_travel_quote') }} #: <span class="text-red-500">{{ data.sk }}</span>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="w-full text-right line-height-3">
        <thead>
          <tr>
            <th class="hidden"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <ul class="no-bullets">
                <li class="text-lg">
                  {{ $t('client_copy.date_submitted') }}: <span>{{ data.created || $t('common.empty') }}</span>
                </li>
                <li class="text-lg">
                  {{ $t('client_copy.expires_on') }}: <span>{{ data.expires || $t('common.empty') }}</span>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>
